<template>
  <UserLayout :showNavBar="false" :hideCompanyInfo="true">
    <template #page-content="props">
      <v-row class="d-flex justify-center align-center">
        <v-col xs="12" sm="6" md="4" offset-sm="3" offset-md="4">
          <v-progress-circular
            :size="70"
            :width="7"
            color="white"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
    </template>
  </UserLayout>
  <!-- <div class="mainPage">
    <v-container class="fill-height justify-center page" fluid>
      <v-row class="d-flex justify-center align-center">
        <v-col xs="12" sm="6" md="4" offset-sm="3" offset-md="4">
          <v-progress-circular
            :size="70"
            :width="7"
            color="white"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>

      <v-snackbar v-model="ShowSnackbar" :timeout="5000">
        {{ error }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="error = ''">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-btn
        color="primary"
        elevation="5"
        fab
        large
        medium
        small
        x-large
        x-small
        bottom
        fixed
        @click="Logoff"
        right
        >Esci</v-btn
      >
    </v-container>
  </div> -->
</template>


<style lang="scss">
.mainPage {
  height: 100vh;
  width: 100vw;
  display: flex;
}
</style>


<script>
import router from "../router/index";
import VueRouter from "vue-router";
import EasyPlanClient from "../utils/EasyPlanClient";
import UserLayout from "../layout/UserLayout";
import SessionHelper from "../utils/SessionHelper";
export default {
  data() {
    return {
      error: "",
      companies: [],
    };
  },

  components: {
    UserLayout,
  },
  computed: {
    ShowSnackbar: {
      get() {
        if (this.error != undefined) return this.error.length > 0;
        else return false;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },
  methods: {
    Logoff() {
      console.debug("logging off");
      SessionHelper.Logoff(this.$route.params.companyAlias);
    },
    redirectToFirstCompanyDashboard() {
      console.debug("Carico aziende");
      EasyPlanClient.Company.GetAll()
        .then((res) => {
          console.debug("risposta get all companies:");
          console.debug(res);
          this.companies = res.data.data;
          if (this.companies.length > 0) {
            let alias = this.companies[0].alias;

            SessionHelper.loadCompanyInfo(alias, () => {
              SessionHelper.loadUserInfo(alias, () => {
                this.$router.push({
                  name: "dashboard",
                  params: { companyAlias: this.companies[0].alias },
                });
              });
            });
          } else {
            console.error("company == undefined, redirect in corso");
            SessionHelper.Logoff();
          }
        })
        .catch((error) => {
          
            SessionHelper.Logoff();
          if (error.response != undefined)
            this.error = EasyPlanClient.GetErrorDescription(
              error.response.data.errorCode
            );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
  created: function () {
    if (
      localStorage.userToken == undefined ||
      localStorage.userToken == "null"
    ) {
      console.debug("logging off from dash");
      localStorage.userToken = null;
 
      this.$router.push({
        name: "login-owner",
      });
    } else {
      EasyPlanClient.SetJWT(localStorage.userToken);
      try {
        console.debug("Eseguo redirect");
        this.redirectToFirstCompanyDashboard();
      } catch (error) {
        console.error(error);
        SessionHelper.Logoff();
      }
    }
  },
};
</script>